import classNames from "classnames"

type Props = {
  type: 'standard' | 'engine-standard',
  deletable?: boolean,
  onDelete?: () => void,
  label: string
}

/*
  Voyage tag
  type: 'standard' | 'engine-standard',
  deletable?: boolean
*/

const Tag = ({
  type,
  deletable,
  onDelete,
  label
}: Props) => {
  return (
    <div className={classNames('voyage-tag', { 'deletable': deletable, [`voyage-tag--${type}`]: true })}>
      {label}
      {deletable && <i className="ri-close-line" onClick={onDelete} />}
    </div>
  )
}

export default Tag